import axios from 'axios';

export const BUSINESS_METRICS_SESSION_EXPIRED_MESSAGE = '관리자 세션이 만료되었습니다. 다시 로그인해주세요.';

export const responseStatus = (error: unknown): number | null =>
  axios.isAxiosError(error) && error.response ? error.response.status : null;

/** 운영자에게 보여 줄 오류 문구. 401 은 세션 만료, 403 은 권한, 그 밖은 상태 코드와 원문. */
export const describeBusinessMetricsError = (error: unknown): string => {
  const status = responseStatus(error);
  if (status === 401) return BUSINESS_METRICS_SESSION_EXPIRED_MESSAGE;
  if (status === 403) return '사업 지표를 볼 관리자 권한이 없습니다.';
  if (status === 404) return '사업 지표 API(/api/v1/metrics/business)가 아직 배포되지 않았습니다.';
  if (status !== null) return `사업 지표를 불러오지 못했습니다 (HTTP ${status}).`;
  const message = error instanceof Error ? error.message : String(error);
  if (message === BUSINESS_METRICS_SESSION_EXPIRED_MESSAGE) return message;
  return `사업 지표를 불러오지 못했습니다: ${message}`;
};
